import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTire } from "@awesome.me/kit-7e217e7a3f/icons/classic/solid";
import Image from "next/image";
import Logo from "@/app/images/Logo-Granuband_pay-off-1280x405-RGB.svg";
import { createMachineTestRead } from "@/app/api/api";
import { WebSocketStatus } from "@/app/hooks/useWebSocket";

const Loader = ({
  loading,
  status,
}: {
  loading: boolean;
  status: WebSocketStatus;
}) => {
  // const icon = loading ? "faTire" : "faTire";

  const handleClick = async () => {
    try {
      const data = await createMachineTestRead();
      console.log("Data received:", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div
      className={`${
        loading ? "visible" : "hidden"
      } fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm`}
    >
      <div className="loader-inner flex flex-col items-center justify-center gap-4">
        <FontAwesomeIcon
          icon={faTire}
          size="10x"
          color="var(--granu-green)"
          spin
        />
        <h1 className="text-foreground text-2xl">
          {status === "reconnecting"
            ? "Verbinding verbroken – opnieuw verbinden..."
            : status === "connecting"
            ? "Verbinding maken met server..."
            : "Wacht op nieuwe band..."}
        </h1>{" "}
        <button
          className="p-2 bg-[var(--granu-green)] text-white rounded-sm hover:bg-gray-300 hover:text-black w-lg transition-colors duration-300 ease-in-out"
          onClick={handleClick}
          title="Test API"
        >
          Test Lezing
        </button>
      </div>
      <Image
        src={Logo}
        alt="Granuband Logo"
        className="absolute bottom-10 right-10 transform"
        width={300}
        height={50}
      />
    </div>
  );
};

export default Loader;
